import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Email Verified page — shown after Keycloak email verification.
 * Completely standalone (no AuthContext dependency).
 * Redirects directly to Keycloak login via window.location.
 */
export default function EmailVerified() {
  const { t } = useTranslation();
  useEffect(() => {
    const timer = setTimeout(() => {
      // Redirect direct la Keycloak login page prin SDK-less approach
      // Keycloak va construi sesiunea și va trimite la /dashboard
      const loginUrl =
        `${window.location.origin}/auth/realms/didi-clients/protocol/openid-connect/auth` +
        `?client_id=didi-web-app` +
        `&redirect_uri=${encodeURIComponent(window.location.origin + '/dashboard')}` +
        `&response_type=code` +
        `&scope=openid`;
      window.location.href = loginUrl;
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#050510',
      color: '#ffffff',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      gap: '16px',
    }}>
      <div style={{
        width: '64px',
        height: '64px',
        borderRadius: '50%',
        background: 'rgba(16, 185, 129, 0.1)',
        border: '2px solid #10b981',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <svg viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
          <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
          <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
      </div>

      <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 700 }}>
        {t('emailVerified.title')}
      </h2>

      <p style={{ margin: 0, color: 'rgba(255,255,255,0.6)', fontSize: '16px' }}>
        {t('emailVerified.redirecting')}
      </p>

      <div style={{
        width: '24px',
        height: '24px',
        border: '3px solid rgba(255,255,255,0.1)',
        borderTopColor: '#A855F7',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
